import { render, staticRenderFns } from "./empty-permissions-page.vue?vue&type=template&id=3dc78ad4&scoped=true&"
import script from "./empty-permissions-page.vue?vue&type=script&lang=js&"
export * from "./empty-permissions-page.vue?vue&type=script&lang=js&"
import style0 from "./empty-permissions-page.vue?vue&type=style&index=0&id=3dc78ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc78ad4",
  null
  
)

export default component.exports